import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Typography, useTheme, useMediaQuery } from "@mui/material";
import { Container } from "@mui/material";
import HtmlRender from "../../components/HtmlRender/HtmlRender";
import AppBarCustom from "../../components/AppBar";
import { NewsContainer, NewsImage, NewsContent } from "./styles";
const apiUrl = process.env.PORTAL_URL || "http://localhost:7004";
export const News = (data) => {
    var _a;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    return (_jsxs(_Fragment, { children: [_jsx(AppBarCustom, { pages: data.pages || [], navegatePage: data.navegatePage }), _jsx(Container, Object.assign({ maxWidth: "lg" }, { children: _jsxs(NewsContainer, { children: [_jsx(Typography, Object.assign({ variant: isMobile ? "h5" : "h4", component: "h1", sx: {
                                mb: isMobile ? 3 : 5,
                                fontSize: isMobile ? "1.5rem" : "2.125rem",
                                lineHeight: isMobile ? 1.3 : 1.4,
                                fontWeight: 600,
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                            } }, { children: data === null || data === void 0 ? void 0 : data.noticia.title })), _jsx(NewsImage, { src: `${apiUrl}/api/hemoes/assets/${data.noticia.thumbnail}`, alt: "Thumbnail" }), _jsx(NewsContent, { children: _jsx(HtmlRender, { html: ((_a = data === null || data === void 0 ? void 0 : data.noticia) === null || _a === void 0 ? void 0 : _a.content) || "" }) })] }) }))] }));
};
